import { FC, useContext, useEffect } from 'react';
import Section from '../../../components/Main/Section/Section';
import { useTranslation } from 'react-i18next';
import { CurrentViewContext } from '../../../providers/CurrentViewProvider';

const Evaluation: FC = () => {
  const { t } = useTranslation();
  const { setCurrentView } = useContext(CurrentViewContext);

  useEffect(() => {
    setCurrentView(t('nav_evaluation'));
    document.title = `Reputativ ${t('nav_evaluation')}`;
  }, [setCurrentView, t]);

  return (
    <Section>
      <></>
    </Section>
  );
};

export default Evaluation;
